import { populate } from 'populate';import dragonBones from 'pixi-dragonbones';

const raw = {
  width: 1351,
  height: 760,
  x: 0,
  y: 0,
  list: [
    {
      id: 'aa326fed-acc2-4db5-b4f9-d98bd9a6c529',
      type: 'Container',
      name: 'root',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: ''
    },
    {
      id: '7db9cff8-25cd-4705-bb79-eaa243a1883b',
      type: 'NineSlicePlane',
      name: 'warning',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 1351,
      height: 760,
      leftWidth: 0,
      topHeight: 0,
      rightWidth: 0,
      bottomHeight: 0,
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'red_rect',
      parent: 'aa326fed-acc2-4db5-b4f9-d98bd9a6c529',
      data: ''
    },
    {
      id: '17c057bd-078e-49ad-b324-1c5b1f5f8632',
      type: 'Sprite',
      name: 'overlay',
      nameSpace: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'TNTModifierFullOverlay',
      parent: 'aa326fed-acc2-4db5-b4f9-d98bd9a6c529',
      data: ''
    }
  ],
  version: '1.0.x'
} as const;

export class TNTModifierScreenWarningLayout {
  static raw = raw;
  root: PIXI.Container
  warning: PIXI.NineSlicePlane
  overlay: PIXI.Sprite

  constructor() {
    populate(this, raw);
  }
}
